import { Tab, Tabs, Typography } from "@mui/material";
import React, { memo } from "react";
import theme from "../../theme";
import { testIds } from "./LynksTabs.testIds";

type LynksTab = {
  value: any;
  label: string;
  hidden?: boolean;
  testId?: string;
};

type LynksTabsProps = {
  tabs: Array<LynksTab>;
  value: any;
  onSelectTab: (tab: LynksTab["value"]) => void;
};

const defaultTabTestId = (value: LynksTab["value"]) =>
  `lynks-tabs-tab-${String(value)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")}`;

const LynksTabs = memo(({ tabs, onSelectTab, value }: LynksTabsProps) => (
      <Tabs data-testid={testIds.lynksTabsNavigation}
    TabIndicatorProps={{
      style: {
        display: "none",
      },
    }}
    sx={{
      width: "100%",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.primaryBackground.dark,
      borderRadius: 2,
      mb: 2,
    }}
    value={value}
    onChange={(event, value) => {
      onSelectTab(value);
    }}
    aria-label="users filter tab"
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
  >
    {tabs.map((tab, i) => {
      if (tab.hidden) {
        return null;
      }
      const isActive = value === tab.value;
      return (
        <Tab data-testid={tab.testId ?? defaultTabTestId(tab.value)}
          key={tab.value}
          sx={{
            flex: 1,
            maxWidth: "none",
            backgroundColor: isActive
              ? theme.palette.primaryBackground.main
              : "white",
            borderRightWidth: i < tabs.length - 1 ? 1 : 0,
            borderStyle: "solid",
            borderColor: theme.palette.primaryBackground.dark,
          }}
          label={
            <Typography
              fontWeight={isActive ? "600" : "500"}
              fontSize={13}
              color="primary"
            >
              {tab.label}
            </Typography>
          }
          value={tab.value}
        />
      );
    })}
  </Tabs>
));

export default LynksTabs;
